import React from "react";
import styled from "styled-components";

type Props = {
  bgcolor?: string;
  progress: number;
  total: number;
  height: number;
};

const Track = styled.div<{ h: number }>`
  height: ${({ h }) => h}px;
  width: 100%;
  background: var(--gray-100);
  border-radius: 3px;
  overflow: hidden;
`;

const Fill = styled.div<{ percent: number; barColor: string }>`
  height: 100%;
  width: ${({ percent }) => percent}%;
  background: ${({ barColor }) => barColor};
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  transition: width 1s ease;
`;

const ProgressText = styled.span`
  padding: 0 6px;
  font-family: var(--font-mono);
  font-weight: 700;
  font-size: 0.65rem;
  color: #fff;
  text-shadow: 0 1px 2px rgba(0,0,0,.3);
`;

const ProgressBar: React.FC<Props> = ({ progress, total, height }) => {
  const percent = Math.min((progress / total) * 100, 100);

  const getColor = () => {
    if (progress >= total * 0.8) return "var(--red)";
    if (progress >= total * 0.5) return "#f59e0b";
    return "#0ea572";
  };

  return (
    <Track h={height}>
      <Fill percent={percent} barColor={getColor()}>
        <ProgressText>{progress}</ProgressText>
      </Fill>
    </Track>
  );
};

export default ProgressBar;
